<p>
  @switch (issue()) {
    @case ('not-configured') {
      CUE Assist is not configured, contact your administrator.
    }

    @case ('missing-license') {
      CUE Solution license is invalid, contact your administrator.
    }

    @default {
      Error bootstrapping CUE Assist, contact your administrator.
    }
  }
</p>
